<template>
  <div>
    <!-- LIST START -->
    <template>
      <!-- {{ items }} -->
      <v-card class="mx-auto" max-width="500" tile>
        <v-list dense rounded>
          <!-- <v-subheader>{{selectedEventText}}</v-subheader> -->
          <v-list-item-group v-model="selectedListItem" color="orange">
            <v-list-item
              v-for="(item, i) in items"
              :key="i"
              @click="setSelectedItem(item)"
              single-line
              dense
            >
              <!-- <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon> -->
              <v-list-item-content>
                <v-row align="center">
                  <v-col cols="1">
                    <v-list-item-icon v-if="item.IsOpen">
                      <v-icon :color="item.Color"
                        >mdi-lock-open-variant-outline</v-icon
                      >
                    </v-list-item-icon>
                    <v-list-item-icon v-else>
                      <v-icon :color="item.Color">mdi-lock-outline</v-icon>
                    </v-list-item-icon>
                  </v-col>
                  <v-col class="d-flex flex-no-wrap justify-space-around">
                    <v-col>
                      <v-list-item-title>{{ item.Event }}</v-list-item-title>
                    </v-col>
                    <v-col>
                      <v-chip
                        color="primary"
                        dark
                        rounded
                        small
                        :to="item.ToLsbLink"
                        v-if="item.Ant > 0"
                        >Activity ({{ item.Ant }})
                        <v-icon right small>mdi-edit-outline</v-icon></v-chip
                      >
                      <!-- <small>{{ item.Comment }}</small> -->
                    </v-col>
                    <v-col>
                      <v-chip
                        color="primary"
                        dark
                        rounded
                        small
                        :to="item.ToLsbLink"
                        v-if="item.AntPos > 0"
                        >Map ({{ item.AntPos }})
                        <v-icon right small>mdi-edit-outline</v-icon></v-chip
                      >
                      <!-- <small>{{ item.Comment }}</small> -->
                    </v-col>
                  </v-col>
                </v-row>

                <v-list-item-subtitle v-if="item.IsOpen">{{
                  item.Comment
                }}</v-list-item-subtitle>
                <v-divider></v-divider>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>
        </v-list>
      </v-card>
    </template>
  </div>
</template>
<!-- LIST SLUTT -->

<script>
// import axios from "axios";

export default {
  name: "BoxesByList",
  props: {
    items: {
      type: Array,
    },
    loading: Boolean,
  },
  data() {
    return {
      e1: 1,
      search: "",
      lsblink: "/airbox/0",
      selectedListItem: -1,
    };
  },
  methods: {
    setSelectedItem(item) {
      this.lsblink = "/airbox/" + item.EventId;
      // this.router.push(this.lsblink);
    },
  },
};
</script>